import Layout from '../../internal/Layout.vue'
import index from './index.vue'

const AnalyserRoutes = {
  component: Layout,
  children: [
    {
      name: 'analysers',
      path: '/',
      component: index,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
      },
    },
  ],
}

export default AnalyserRoutes
